var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEtiquettesW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 37.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_358",
    "data-name": "Groupe 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_325",
    "data-name": "Groupe 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3971",
    "data-name": "Trac\\xE9 3971",
    d: "M12.27,28.6a.61.61,0,0,1-.42-.17.62.62,0,0,1,0-.84L21,18.41a.59.59,0,1,1,.84.84l-9.18,9.18A.59.59,0,0,1,12.27,28.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3972",
    "data-name": "Trac\\xE9 3972",
    d: "M9.91,26.24a.59.59,0,0,1-.42-1h0l9.18-9.18a.59.59,0,0,1,.83,0h0a.6.6,0,0,1,0,.84l-9.18,9.18A.59.59,0,0,1,9.91,26.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3973",
    "data-name": "Trac\\xE9 3973",
    d: "M15.08,37.83h0a2.16,2.16,0,0,1-1.54-.61L.62,24.32A2.13,2.13,0,0,1,0,22.78a3.05,3.05,0,0,1,.93-2.13L13.79,7.75A5,5,0,0,1,17,6.46c.06,0,7.43-.61,11.5-.52a.62.62,0,0,1,.41.18l2.95,2.94a.58.58,0,0,1,.17.41c0,4-.54,11.17-.54,11.24s0,.08,0,.12c-.08.26-.13.5-.19.75a4.12,4.12,0,0,1-1.1,2.33l-12.92,13A3.13,3.13,0,0,1,15.08,37.83ZM27.48,7.12c-4.12,0-10.36.51-10.42.52a4,4,0,0,0-2.44,1L1.77,21.49a1.86,1.86,0,0,0-.59,1.29,1,1,0,0,0,.27.7l12.92,12.9a1,1,0,0,0,.71.27,1.92,1.92,0,0,0,1.31-.59l12.92-13a3,3,0,0,0,.79-1.74c0-.26.11-.52.18-.79.06-.68.57-7.06.54-10.82L28.21,7.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3974",
    "data-name": "Trac\\xE9 3974",
    d: "M20.82,4.59l-.41-.43c-3-3-7.06-5.26-8.72-3.6-1.17,1.17-.39,3.52,1.21,5.86a4.94,4.94,0,0,1,.88-.64c-1.48-2.17-1.85-3.91-1.32-4.45.73-.72,3.68.22,6.91,3.35l.27.25a17.18,17.18,0,0,1,3,3.93,6.87,6.87,0,0,1,.77,2.05,2.83,2.83,0,0,0-.63.46,2.7,2.7,0,0,0-.6.93A2.6,2.6,0,0,0,22,13.4a2.74,2.74,0,1,0,2.48-2.8,7.65,7.65,0,0,0-.64-1.79A17.8,17.8,0,0,0,20.82,4.59Zm5.06,9.87a1.63,1.63,0,0,1-2.31,0,1.7,1.7,0,0,1-.48-1.1,1.81,1.81,0,0,0,.91-.49,1.85,1.85,0,0,0,.54-1.19,1.63,1.63,0,0,1,1.34,2.78Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEtiquettesW);
export default __webpack_public_path__ + "static/media/ic-etiquettes-w.e243174f947da144ba6bfdb351fc83f5.svg";
export { ForwardRef as ReactComponent };